import React, { useEffect, useState, useRef } from 'react'
import { Container, Box, Text, Image, Button } from '@chakra-ui/react'
import axios from 'axios'
import { ChatState } from '../context/chatProvider'
import  SideDrawer  from '../components/misc/SideDrawer'
import  MyChats  from '../components/MyChats'
import ChatBox  from '../components/ChatBox'
import  useIntersection  from '../hooks/useIntersection';

const refreshPage = ()=>{window.location.reload(true);}
  //  refreshPage()
let r_c 
const ChatView = () => {
  
  // const ref = useRef();
  // const inViewport = useIntersection(ref);
  const [fetchAgain, setFetchAgain] = useState(false);
 const {user} = ChatState()
if(!user && (r_c < 1)){
  refreshPage() 
  r_c++
}
  // if (!ref['current']==='undefined') {
  //       console.log('in viewport:', ref);
  //   }

  return (
    <div style = {{ width: "100%" }} >
        {user &&<SideDrawer />}
        <Box 
            display="flex"
            justifyContent={"space-between"}
            w="100%"
            h="81.5vh"
            p="10px"
        >
         {user && <MyChats fetchAgain={fetchAgain} />}
        {user && (
          <ChatBox fetchAgain={fetchAgain} setFetchAgain={setFetchAgain} />
        )}
      {!user && <Button alignSelf={'center'} onClick={()=>{refreshPage()}} >Refresh</Button>}
      
        </Box>
    </div>
   
  )
}

export default ChatView